import React, { Component } from "react";
import { Link } from "react-router-dom";
import { slide as Menu } from "react-burger-menu";
import "../css/sidebar.css";
import logo from "../images/web-icons/logo_transparent.png";

export default class Header extends Component {
  constructor(props) {
    super(props);
    this.handleScroll = this.handleScroll.bind(this);

    this.state = {
      headerTopScreen: false,
    };
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  }

  handleScroll(event) {
    var height = window.innerHeight;

    var top = window.scrollY;

    var headerTopScreen = top >= height * 0.4;
    this.setState({
      headerTopScreen: headerTopScreen,
    });
  }

  render() {
    const styleHeader = {};
    if (this.props.customColor) {
      styleHeader.backgroundColor = this.props.customColor;
    }

    styleHeader.position = "fixed";

    const lightColor = this.props.lightColor;

    const styleClassMenu = (lightColor ? "light" : "dark") + "-font-color";

    const showLogo =
      this.props.showLogo !== undefined ? this.props.showLogo : true;

    return (
      <header id="header" class="header_active" style={{ ...styleHeader }}>
        {showLogo ? (
          <div id="header_title" class="header_title">
            <Link to="/">
              <img src={logo} />
              <h1 className={styleClassMenu}>
                <b>David</b>Šimák
              </h1>
            </Link>
          </div>
        ) : null}

        <div className="header_nav_container">
          <nav class="header_nav">
            <ul>
              <li>
                <Link to="/contact" className={styleClassMenu}>
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/projects" className={styleClassMenu}>
                  Projects
                </Link>
              </li>
              <li>
                <Link to="/experience" className={styleClassMenu}>
                  Experience
                </Link>
              </li>
              <li>
                <Link to="/about" className={styleClassMenu}>
                  About Me
                </Link>
              </li>
            </ul>
          </nav>
        </div>

        <Menu
          burgerBarClassName={
            lightColor ? "bm-burger-bars-light" : "bm-burger-bars-dark"
          }
          width="100%"
        >
          <Link to="/about" className="light-font-color mobile-menu-text">
            About Me
          </Link>
          <Link to="/experience" className="light-font-color mobile-menu-text">
            Experience
          </Link>

          <Link to="/projects" className="light-font-color mobile-menu-text">
            Projects
          </Link>
          <Link to="/contact" className="light-font-color mobile-menu-text">
            Contact
          </Link>
        </Menu>
      </header>
    );
  }
}
